// @flow
import * as React from 'react';
import './ErrorCodes.scss';
import {Heading} from 'docs/components';
import Icon from 'sail/Icon';
import {renderMarkdocAsReact} from 'docs/markdoc';
import {InlineCode} from '../../core/InlineCode/InlineCode';

type ErrorCodeProps = {|
  name: string,
  documentation: string,
|};
type ErrorCodesProps = {|
  codesList: Array<ErrorCodeProps>,
|};

const ErrorCode = ({name, documentation}: ErrorCodeProps) => {
  return (
    <div>
      <dt>
        <Icon className="inline" icon="checkCircle" color="green" />
        <Heading
          className="inline"
          level={3}
          id={name.replace(/_/g, '-')}
          anchored
        >
          <InlineCode>{name}</InlineCode>
        </Heading>
      </dt>
      <dd>{renderMarkdocAsReact(documentation)}</dd>
    </div>
  );
};

export const ErrorCodes = ({codesList}: ErrorCodesProps) => {
  return (
    <dl className="ErrorCodes">
      {codesList.map((code) => {
        return (
          <ErrorCode name={code.name} documentation={code.documentation} />
        );
      })}
    </dl>
  );
};
